import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import type { ParityManagerFiltersMarketInfo } from 'lumen/models';
import ApplicationSerializer from 'lumen/serializers/application';

export default class MarketInfoSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'all_channels') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-manager/filters/channel');
    }

    if (key === 'assignees') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-manager/filters/assignee');
    }

    if (key === 'status_list') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-manager/filters/status');
    }

    if (key === 'root_causes') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-manager/filters/root-cause');
    }

    if (key === 'escalation_levels') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey(
        'parity-manager/filters/escalation-level',
      );
    }

    if (key === 'entry_modes') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-manager/filters/entry-mode');
    }

    if (key === 'marketplaces') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey(
        'parity-manager/filters/marketplace',
      );
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: object,
    id: string | number,
    requestType: string,
  ) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    const normalizedResponse = super.normalizeResponse(
      store,
      primaryModelClass,
      payload,
      id,
      requestType,
    ) as {
      data: ParityManagerFiltersMarketInfo[];
      included: ParityManagerFiltersMarketInfo[];
    };

    // MarketInfo is an artificial model that is not backed by a server-side resource.
    // Overwrite data with sideloaded data (Channel, Assignee, EntryMode, EscalationLevel, RootCause, Status)
    normalizedResponse.data = [...normalizedResponse.included];
    normalizedResponse.included = [];
    return normalizedResponse;
  }
}
